import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { NavigationService } from '@egret/shared/services/navigation.service';
import { ThemeService } from '@egret/shared/services/theme.service';
import { Subscription } from 'rxjs';
import { ILayoutConf, LayoutService } from '@egret/shared/services/layout.service';
import { UserService } from 'bookraw/shared/services/user.service';
import { version } from 'root/package.json';
import { environment } from 'env/environment';

@Component({
  selector: 'app-sidebar-side',
  templateUrl: './sidebar-side.component.html',
  styles: [`
    .sidebar-version { margin-top: 25px; width: 100%; text-align: center; color: var(--bookr__breadcrumb); }
    .sidebar-version-scroll { position: relative; margin-top: 15px; }
    .app-user {
      text-align: left;
      border-bottom: 1px solid #ffffff26;
      padding: 0 16px 10px 16px;
    }`
  ]
})
export class SidebarSideComponent implements OnInit, OnDestroy, AfterViewInit {
  public menuItems: any[];
  public hasIconTypeMenuItem: boolean;
  public iconTypeMenuTitle: string;
  private menuItemsSub: Subscription;
  public layoutConf: ILayoutConf;
  public version = version;
  public logo = environment.logo;

  constructor(
    private navService: NavigationService,
    private themeService: ThemeService,
    private layout: LayoutService,
    public userService: UserService,
  ) {
  }

  ngOnInit() {
    this.iconTypeMenuTitle = this.navService.iconTypeMenuTitle;
    this.menuItemsSub = this.navService.menuItems$.subscribe(menuItem => {
      this.menuItems = menuItem;
      // Checks item list has any icon type.
      this.hasIconTypeMenuItem = !!this.menuItems.filter(
        item => item.type === 'icon'
      ).length;
    });
    this.layoutConf = this.layout.layoutConf;
  }
  ngAfterViewInit() {}
  ngOnDestroy() {
    if (this.menuItemsSub) {
      this.menuItemsSub.unsubscribe();
    }
  }
  toggleCollapse() {
    if (
      this.layoutConf.sidebarCompactToggle
    ) {
      this.layout.publishLayoutChange({
        sidebarCompactToggle: false
      });
    } else {
      this.layout.publishLayoutChange({
        // sidebarStyle: "compact",
        sidebarCompactToggle: true
      });
    }
  }
  logout() {
    this.userService.logout();
  }
}
